/* Hooks */
import useMst from '~/src/hooks/useMst';

/* Configurations */
import { LAYOUT_MODAL_TYPES } from '~/src/components/PageLayout/Modals';
import { LAYOUT_SLIDEIN_TYPES } from '~/src/components/PageLayout/SlideIns';
import { VALIDATION_TYPES } from '~/src/utils/validation';
import { useLayoutContext } from '../contexts/Layout';

const useTemplatesActions = () => {
  const { showSlideIn, hideModal, showModal } = useLayoutContext();

  const {
    selectTemplate,
    deleteTemplate,
    updateTemplate,
    addTemplateToSeletionSidebar,
  } = useMst((store) => ({
    selectTemplate: store.templates.selectTemplate,
    deleteTemplate: store.templates.deleteTemplate,
    updateTemplate: store.templates.updateTemplate,
    addTemplateToSeletionSidebar: store.templates.addTemplateToSeletionSidebar,
  }));

  const handlePreviewTemplate = (template, hideAddToSelection = false) => {
    showSlideIn(LAYOUT_SLIDEIN_TYPES.documentPreview, {
      largeSlideIn: true,
      templateObj: template,
      templateId: template.id,
      hideAddToSelection,
    });
  };
  const handleRenameTemplate = (template) => {
    const handleRenameConfirm = async (form) => {
      const { value } = form.fields.name;
      try {
        await updateTemplate(template.id, { name: value });
        hideModal();
      } catch (error) {
        // Check if it's a 403 error (forbidden)
        if (error.response?.status === 403) {
          showModal(LAYOUT_MODAL_TYPES.error, {
            title: 'Unable to Rename Template',
            messages: ['You do not have permission to modify this template.'],
            onCancel: hideModal,
          });
        } else {
          showModal(LAYOUT_MODAL_TYPES.error, {
            title: 'Error Renaming Template',
            messages: [
              'An error occurred while renaming the template. Please try again.',
            ],
            onCancel: hideModal,
          });
        }
      }
    };

    showModal(LAYOUT_MODAL_TYPES.formField, {
      title: 'Rename Template',
      primaryActionTitle: 'Save',
      fields: [
        {
          label: 'Name',
          id: 'name',
          type: 'text',
          defaultValue: template.title,
          validation: VALIDATION_TYPES.templateName,
        },
      ],
      onConfirm: handleRenameConfirm,
    });
  };
  const handleDeleteTemplate = (template) => {
    const handleDeleteConfirm = async () => {
      try {
        await deleteTemplate(template.id);
        hideModal();
      } catch (error) {
        // Check if it's a 403 error (forbidden)
        if (error.response?.status === 403) {
          showModal(LAYOUT_MODAL_TYPES.error, {
            title: 'Unable to Delete Template',
            messages: ['You do not have permission to modify this template.'],
            onCancel: hideModal,
          });
        } else {
          showModal(LAYOUT_MODAL_TYPES.error, {
            title: 'Error Deleting Template',
            messages: [
              'An error occurred while deleting the template. Please try again.',
            ],
            onCancel: hideModal,
          });
        }
      }
    };

    showModal(LAYOUT_MODAL_TYPES.confirm, {
      title: `Delete Template ${template.title}?`,
      message: `This will permanently delete the template from your organization. This action cannot be undone.`,
      onConfirm: handleDeleteConfirm,
      primaryActionTitle: 'Delete',
      destructive: true,
    });
  };
  const handleSelectTemplate = (templateId) => {
    selectTemplate(templateId);
  };

  const handleAddTemplateToSeletionSidebar = (template) => {
    addTemplateToSeletionSidebar(template);
  };

  return {
    previewTemplate: handlePreviewTemplate,
    renameTemplate: handleRenameTemplate,
    deleteTemplate: handleDeleteTemplate,
    selectTemplate: handleSelectTemplate,
    addTemplateToSeletionSidebar: handleAddTemplateToSeletionSidebar,
  };
};

export default useTemplatesActions;
